import AddNotice from "src/pages/Notice/AddNotice";
import NoticeList from "src/pages/Notice/NoticeList";

export const noticeRoutes = [
  { path: '/notice', component: NoticeList },
];
